import type { GetStaticProps } from "next"
import { PageMeta } from "@/components/resources/components/Seo/PageMeta"
import {
  type CategoryPageProps,
  getSingleCategoryPageProps,
} from "@/components/resources/data/sanity/posts"
import { SiteLayout } from "@/components/resources/layouts/site"
import { CategoryArchive } from "@/components/resources/templates/CategoryArchive"
import {
  getAllEngineeringPosts,
  getEngineeringPageMeta,
  postMetaToTeaser,
} from "@/utils/engineering-blog"

const Archive = ({ entries, title, lead, category, meta }: CategoryPageProps) => {
  return (
    <>
      <PageMeta meta={meta} />
      <CategoryArchive
        entries={entries}
        categories={[]}
        category={category}
        title={title}
        lead={lead}
      />
    </>
  )
}

Archive.getLayout = SiteLayout

export default Archive

export const getStaticProps: GetStaticProps<CategoryPageProps> = async () => {
  // Markdown-based engineering posts
  const mdPosts = getAllEngineeringPosts()
  const mdEntries = mdPosts.map(postMetaToTeaser)

  // Sanity CMS posts tagged "engineering"
  let sanityEntries: CategoryPageProps["entries"] = []
  try {
    const sanityProps = await getSingleCategoryPageProps("engineering")
    if (sanityProps?.entries) {
      sanityEntries = sanityProps.entries
    }
  } catch (error) {
    console.error("Failed to fetch Sanity engineering posts:", error)
  }

  // Merge both sources and sort by date (newest first)
  const entries = [...mdEntries, ...sanityEntries].sort((a, b) => {
    const bt = new Date(b.publishedAt).getTime()
    const at = new Date(a.publishedAt).getTime()
    if (Number.isNaN(at)) return 1
    if (Number.isNaN(bt)) return -1
    return bt - at
  })

  const meta = getEngineeringPageMeta()

  return {
    props: {
      entries,
      categories: [],
      title: "Engineering",
      lead: "Technical posts from the Token Terminal engineering team",
      category: "engineering",
      meta,
    },
    revalidate: 180,
  }
}
